import { isHTMLElementNode } from '../../serialization/helpers/serializerHelpers';
import { type InfoBlockType } from '../../types/aha-editor';

export const INFO_BLOCK_DEPRECATED_CLASS = 'aha-editor-v2__infoBlock';
export const INFO_BLOCK_DEPRECATED_CLASS_PREFIX = 'aha-editor-v2__infoBlock--';

// The allowed types of info blocks.
export const infoBlockTypes: InfoBlockType[] = [
  'infoBlock',
  'noteBlock',
  'warningBlock',
  'tipBlock',
];

export function isInfoBlockNode(el: Node): el is HTMLParagraphElement {
  return Boolean(
    isHTMLElementNode(el) &&
      el.tagName.toLowerCase() === 'p' &&
      (el.dataset.calloutBoxType ||
        el.classList.contains(INFO_BLOCK_DEPRECATED_CLASS))
  );
}
